import { render, staticRenderFns } from "./solart-3d.vue?vue&type=template&id=990aa6fc&scoped=true&"
import script from "./solart-3d.vue?vue&type=script&lang=js&"
export * from "./solart-3d.vue?vue&type=script&lang=js&"
import style0 from "./solart-3d.vue?vue&type=style&index=0&id=990aa6fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990aa6fc",
  null
  
)

export default component.exports